import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Icon from '@material-ui/core/Icon';
import DeleteIcon from '@material-ui/icons/Delete';
const useStyles = makeStyles((theme) => ({
  root: {
    cursor:'pointer',
    color:'#de1c22',
    margin:'0 3px',
    padding:'0 3px 3px',
    '&:hover':{
      borderRadius:4,
      border:'1px solid #de1c22'
    }
  },
  icon:{
      color:"#de1c22",
      fontSize:16
  }
}));

export default function DeleteActionIcon(props) {
  const {onClick} = props;
  const classes = useStyles();
  return (
    <span className={classes.root} onClick={onClick}>
        <DeleteIcon className={classes.icon} />
    </span>
  );
}